import { useState, useEffect } from "react";
import SupportsAPI from "../../../../api/SupportsAPI";

const useFetchAgentTickets = () => {
	const [loading, setLoading] = useState(false);
	const [tickets, setTickets] = useState([]);

	const fetchAgentTickets = async () => {
		setLoading(true);
		try {
			const result = await SupportsAPI.getOwnTickets();
			setTickets(formatPreprocess(result));
		} catch (error) {
			console.error("Failed to fetch tickets:", error);
			setTickets([]);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	const formatPreprocess = (data) => {
		if (data && Array.isArray(data)) {
			return data.map(({ ticket, messages, history }) => ({
				id: ticket.id,
				ticketId: ticket.ticket_number,
				subject: ticket.subject,
				category: ticket.category,
				dateSubmitted: ticket.created_at,
				status: ticket.status,
				submittedBy: ticket.submitted_by,
				messages,
				history,
			}));
		} else {
			return [];
		}
	};

	useEffect(() => {
		fetchAgentTickets();
	}, []);

	return {
		tickets,
		loading,
		refetch: fetchAgentTickets,
	};
};

export default useFetchAgentTickets;
